import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { setTeamPresencePathname } from "../utils/teamPresenceRouteStore";

/**
 * Mantém o pathname SPA alinhado à telemetria de presença (emit periódico no socket).
 * Deve ficar dentro do Router.
 */
export default function TeamPresenceRouteSync() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    setTeamPresencePathname(`${pathname}${search || ""}`);
  }, [pathname, search]);

  return null;
}
